<div class="schedule">
    <h3>Program</h3>
    <ul class="days">
        <li class="day luni" ng-class="::{'today': ctrl.today == 'luni'}">
            <span>Luni</span>
            <p ng-show="ctrl.program.luni.open">{{::ctrl.program.luni.open}} - {{::ctrl.program.luni.close}}</p>
            <p ng-show="!ctrl.program.luni.open">&#238;nchis</p>
        </li>
        <li class="day marti" ng-class="::{'today': ctrl.today == 'marti'}">
            <span>Mar&#539;i</span>
            <p ng-show="ctrl.program.marti.open">{{::ctrl.program.marti.open}} - {{::ctrl.program.marti.close}}</p>
            <p ng-show="!ctrl.program.marti.open">&#238;nchis</p>
        </li>
        <li class="day miercuri" ng-class="::{'today': ctrl.today == 'miercuri'}">
            <span>Miercuri</span>
            <p ng-show="ctrl.program.miercuri.open">{{::ctrl.program.miercuri.open}} - {{::ctrl.program.miercuri.close}}</p>
            <p ng-show="!ctrl.program.miercuri.open">&#238;nchis</p>
        </li>
        <li class="day joi" ng-class="::{'today': ctrl.today == 'joi'}">
            <span>Joi</span>
            <p ng-show="ctrl.program.joi.open">{{::ctrl.program.joi.open}} - {{::ctrl.program.joi.close}}</p>
            <p ng-show="!ctrl.program.joi.open">&#238;nchis</p>
        </li>
        <li class="day vineri" ng-class="::{'today': ctrl.today == 'vineri'}">
            <span>Vineri</span>
            <p ng-show="ctrl.program.vineri.open">{{::ctrl.program.vineri.open}} - {{::ctrl.program.vineri.close}}</p>
            <p ng-show="!ctrl.program.vineri.open">&#238;nchis</p>
        </li>
        <li class="day sambata" ng-class="::{'today': ctrl.today == 'sambata'}">
            <span>S&#226;mb&#259;t&#259;</span>
            <p ng-show="ctrl.program.sambata.open">{{::ctrl.program.sambata.open}} - {{::ctrl.program.sambata.close}}</p>
            <p ng-show="!ctrl.program.sambata.open">&#238;nchis</p>
        </li>
        <li class="day duminica" ng-class="::{'today': ctrl.today == 'duminica'}">
            <span>Duminic&#259;</span>
            <p ng-show="ctrl.program.duminica.open">{{::ctrl.program.duminica.open}} - {{::ctrl.program.duminica.close}}</p>
            <p ng-show="!ctrl.program.duminica.open">&#238;nchis</p>
        </li>
    </ul>
    <p ng-show="ctrl.exceptions.length > 0">Exceptii de la program:</p>
    <div ng-show="ctrl.exceptions.length > 0" ng-repeat="exception in ::ctrl.exceptions track by $index">
        <p>{{::exception}}</p>
    </div>
</div>